import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: localStorage.adminToken || '',
        user: localStorage.adminUser ? JSON.parse(localStorage.adminUser) : null,
        menus: [],
        currentModule: sessionStorage.currentModule || 'Home',
        leftMenus: sessionStorage.leftMenus ?
            JSON.parse(sessionStorage.leftMenus) : [],
        openName: sessionStorage.openName || '',
        showLoading: false,
        overflow: true,
        commonSetting: {},
        breadList: localStorage.breadList ? JSON.parse(localStorage.breadList) : [],
        currentLeftMenu: localStorage.currentLeftMenu
    },
    mutations: {
        login(state, user) {
            state.user = user;
            state.token = user.remember_token;
            localStorage.adminToken = user.remember_token;
            localStorage.adminUser = JSON.stringify(user);
        },
        logout(state) {
            state.token = '';
            state.user = null;
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
            state.menus = [];
            state.currentModule = '';
            state.leftMenus = [];
            state.currentLeftMenu = '';
            sessionStorage.removeItem('currentModule');
            sessionStorage.removeItem('openName');
            sessionStorage.removeItem('leftMenus');
            localStorage.removeItem('currentLeftMenu');
        },
        setMenus(state, obj) {
            state.menus = obj.menus;
            //== init routes
            // set menu level
            state.menus.forEach(i => {
                i.menu_level = 1;
                i.children &&
                    i.children.forEach(ci => {
                        ci.menu_level = 2;
                    });
            });
            // collect menu map
            const menusMap_name = {};
            const menusMap_id = {};

            function addMenusMap_name(menu) {
                if (!menu.children) {
                    menusMap_name[menu.menu_url] = menu;
                } else {
                    menu.children.forEach(i => {
                        addMenusMap_name(i);
                    });
                }
            }

            function addMenusMap_id(menu) {
                menusMap_id[menu.id] = menu;
                if (menu.children) {
                    menu.children.forEach(i => {
                        addMenusMap_id(i);
                    });
                }
            }
            state.menus.forEach(i => {
                addMenusMap_name(i);
                addMenusMap_id(i);
            });
            // console.log(menusMap_name)
            // console.log(menusMap_id)

            // insert route meta data
            const routes = obj.routes;

            function insertMeta(route) {
                const menu = menusMap_name[route.name];
                if (menu) {
                    let curMenu = menu;
                    while (curMenu) {
                        // get module
                        if (curMenu.menu_level == 1) {
                            if (route.meta) {
                                route.meta.module = curMenu.menu_url;
                            } else {
                                route.meta = {
                                    module: curMenu.menu_url,
                                };
                            }
                        }
                        // get open name
                        if (curMenu.menu_level == 2) {
                            if (route.meta) {
                                route.meta.openName = curMenu.menu_url;
                            } else {
                                route.meta = {
                                    openName: curMenu.menu_url,
                                };
                            }
                        }
                        // next
                        curMenu = menusMap_id[curMenu.parent_id];
                    }
                }
                if (route.children) {
                    route.children.forEach(i => {
                        insertMeta(i);
                    });
                }
            }
            routes.forEach(i => {
                insertMeta(i);
            });
        },
        setCurrentModule(state, module) {
            state.currentModule = module;
            sessionStorage.currentModule = module;
        },
        setOpenName(state, openName) {
            state.openName = openName;
            sessionStorage.openName = openName;
        },
        setLeftMenus(state, leftMenus) {
            state.leftMenus = leftMenus;
            sessionStorage.leftMenus = JSON.stringify(leftMenus);
        },
        showLoading(state) {
            state.showLoading = true;
        },
        hideLoading(state) {
            state.showLoading = false;
        },
        setAvatar(state, avatar) {
            let user = state.user;
            user.avatar = avatar;
            state.user = JSON.parse(JSON.stringify(user));
            localStorage.adminUser = JSON.stringify(user);
        },
        changeOverflow(state, flag) {
            state.overflow = flag;
        },
        setCommonSetting(state, setting) {
            state.commonSetting = setting;
        },
        addBread(state, bread) {
            state.breadList.push(bread);
            localStorage.breadList = JSON.stringify(state.breadList);
        },
        setBreadList(state, list) {
            state.breadList = list;
            localStorage.breadList = JSON.stringify(state.breadList);
        },
        setCurrentLeftMenu(state, left) {
            state.currentLeftMenu = left;
            localStorage.currentLeftMenu = left;
        }
    },
    actions: {},
});